import * as React from 'react'

import { ReactComponent as UploadIconFile } from 'assets/icons/upload-icon.svg'

import { IconStyles } from '../types'
import { UploadCustom } from './styles'

interface UploadProps extends IconStyles {
  onChange?: (_files: React.ChangeEvent<HTMLInputElement>) => void
  onClick?: () => void
  filter?: boolean
  disabled?: boolean
}

const UploadIcon = ({
  onChange,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  disabled,
  onClick
}: UploadProps) => {
  return (
    <UploadCustom
      disabled={disabled}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={disabled ? null : onClick}
      colorIcon={colorIcon}
    >
      <UploadIconFile />
    </UploadCustom>
  )
}

export default UploadIcon
